import { selectComponentDefinitions } from "./groupDefinitions";

export const formComponents = selectComponentDefinitions([
    "Form Tabs",
    "DT Button",
    "DT Input",
    "DT Date Input",
    "DT Select",
    "DT Color Radio",
    "Auto Profile AI",
    "Auto Profile AI 2",
    "DT Email Submit",
]);
